import { languagePrefixes } from '../../i18n';

export const INVESTOR_SOCIAL_HINT =
  'Requires Startup or Professional membership to view details. If you already have a paid account, go to Dashboard -> Find investors.';

export const INVESTOR_CONTACT_HINT =
  'Requires Startup or Professional membership to view contact details. If you already have a paid account, go to Dashboard -> Find investors.';

export const INVESTOR_SOCIAL_KEYS = [
  'website_url',
  'fb_url',
  'linkedin_url',
  'x_url',
  'inst_url',
];

export const INVESTOR_CONTACT_KEYS = ['phone', 'email'];

export const INVESTOR_ACCESS_KEYS = [...INVESTOR_SOCIAL_KEYS, ...INVESTOR_CONTACT_KEYS];

export function hasValue(value) {
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }

  return Boolean(value);
}

export function asString(value) {
  return typeof value === 'string' ? value : value == null ? '' : String(value);
}

export function asArray(value) {
  return Array.isArray(value) ? value : [];
}

export function asNumber(value, fallback = 0) {
  const numberValue = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(numberValue) ? numberValue : fallback;
}

export function getLanguagePrefix(language = 'en') {
  const normalizedLanguage = asString(language).trim().split('-')[0] || 'en';
  const rawPrefix = languagePrefixes[normalizedLanguage] || '';
  return rawPrefix === '' || rawPrefix.startsWith('/') ? rawPrefix : `/${rawPrefix}`;
}

export function hasField(investor, key) {
  if (!investor) {
    return false;
  }

  if (investor?.has && Object.prototype.hasOwnProperty.call(investor.has, key)) {
    const value = investor.has[key];

    if (value === 'yes' || value === true) {
      return true;
    }

    if (typeof value === 'string') {
      return ['true', '1', 'yes'].includes(value.toLowerCase());
    }

    return Boolean(value);
  }

  return hasValue(investor[key]);
}

export function hasAnyInvestorAccessField(investor, keys = INVESTOR_ACCESS_KEYS) {
  return keys.some((key) => hasField(investor, key));
}

export function getInvestorTypes(investor) {
  if (!investor || investor.type == null) {
    return [];
  }

  return asArray(investor.type)
    .length
    ? asArray(investor.type).map(asString).map((item) => item.trim()).filter(Boolean)
    : [asString(investor.type).trim()].filter(Boolean);
}

export function getInvestorIndustries(investor) {
  return asArray(investor?.industries)
    .map(asString)
    .map((item) => item.trim())
    .filter(Boolean);
}

export function buildInvestorProfilePath({
  investor,
  language = 'en',
  inApp = false,
  trailingSlash = false,
  fallbackId,
}) {
  const investorId = investor?.id ?? investor?.uid ?? investor?._id ?? investor?.slug ?? fallbackId;

  if (!investorId) {
    return '#';
  }

  const slug =
    asString(investor?.name)
      .trim()
      .split(/\s+/)
      .map((word) => word.toLowerCase())
      .join('-') || 'investor';

  const prefix = getLanguagePrefix(language);
  const basePath = inApp ? '/app/investor-profile' : '/investor-profile';
  const suffix = trailingSlash ? '/' : '';

  return `${prefix}${basePath}/${investorId}-${encodeURIComponent(slug)}${suffix}`;
}
